// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1xlLz","filesListContainer":"PosDisputesFiles_filesListContainer__2r43b","filesButton":"PosDisputesFiles_filesButton__3j3NR"};